
import { mapState } from "vuex";
import ReportHeaderDateRangeSelector from "./report-header-date-range-selector.vue";
import ReportItemWisePeakHours from "./report-item-wise-peak-hours.vue";
import ReportItemWiseComparison from "./report-item-wise-comparison.vue";
import ReportItemWiseFrequentlyBought from "./report-item-wise-frequently-bought.vue";
export default {
  props: {
    sortedItems: {
      type: Array,
      default: () => []
    },

    selectedIndex: {
      type: Number,
      default: 0
    }
  },
  components: {
    ReportHeaderDateRangeSelector,
    ReportItemWisePeakHours,
    ReportItemWiseComparison,
    ReportItemWiseFrequentlyBought
  },
  data() {
    return {
      currentIndex: this.selectedIndex,
      startDateSelected: "",
      endDateSelected: "",
      dateRangeSelected: ""
    };
  },
  mounted() {
    this.startDateSelected = this.selectedStartDate;
    this.endDateSelected = this.selectedEndDate;
    this.dateRangeSelected = this.selectedTimeRange;
  },
  computed: {
    ...mapState("report", [
      "selectedRestaurants",
      "selectedTimeRange",
      "selectedStartDate",
      "selectedEndDate"
    ]),

    itemName() {
      return this.sortedItems[this.currentIndex].find(
        (item) => item.value === "name"
      ).label;
    },
    currentItem() {
      return this.sortedItems[this.currentIndex];
    }
  },
  methods: {
    handlePreviousButtonClick() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    handleNextButtonClick() {
      if (this.currentIndex < this.sortedItems.length - 1) {
        this.currentIndex++;
      }
    },
    fetchReport(dateRangeSelected) {
      this.startDateSelected = dateRangeSelected?.selectedStartDate;
      this.endDateSelected = dateRangeSelected?.selectedEndDate;
      this.dateRangeSelected = dateRangeSelected?.selectedTimeRange;
      let payload = {};
      payload.start_date = dateRangeSelected?.selectedStartDate;
      payload.end_date = dateRangeSelected?.selectedEndDate;
      payload.restaurant_ids = this.selectedRestaurants;

      this.$axios
        .get(`/reports/overall_sales`, {
          params: payload,
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          if (response?.status === 200) {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((err) => {
          reject(err);
        });
    }
  }
};
